/**
 * Replaces `{{key}}` placeholders in a string with values from the provided map.
 *
 * @example
 * replaceParams('Hello {{name}}!', { name: 'World' }) // 'Hello World!'
 */
export const replaceParams = (str: string, params: Record<string, string | number>): string =>
  str.replace(/{{(\S+?)}}/g, (match, key) => (key in params ? `${params[key]}` : match));
